import React from 'react';

const DEFAULT_ITEMS = [
  { text: 'New meter installed at Site #A102', time: '2h ago', tone: 'info' },
  { text: 'Meter ID #MTR-4582 marked as pending for verification', time: '3h ago', tone: 'warn' },
  { text: 'Meter ID #MTR-4521 successfully verified and commissioned', time: '4h ago', tone: 'success' },
  { text: 'Meter ID #MTR-4498 rejected during commissioning', time: '5h ago', tone: 'danger' },
  { text: 'Field Officer Rahul assigned to Site #B210 installation', time: '6h ago', tone: 'info' },
];

export default function RecentActivityCard({ items = DEFAULT_ITEMS, title = 'Recent Activity' }) {
  return (
    <div className="dash-card">
      <div className="dash-card-head">
        <h3 className="dash-card-title">{title}</h3>
      </div>

      <div className="activity-list" role="list">
        {items.map((it, idx) => (
          <div key={`${idx}-${it.time}`} className="activity-item" role="listitem">
            <span className={`activity-dot ${it.tone || 'info'}`} aria-hidden="true" />
            <div className="activity-main">
              <div className="activity-text">{it.text}</div>
              <div className="activity-time">{it.time}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

